<template>
  <el-collapse v-model="activeNames" @change="handleChange" class="top">
    <el-card class="box-card" v-for="(item, index) in list" :key="index" shadow="hover">
      <el-collapse-item :name="index">
        <template slot="title">
          <span class="title">{{ item.name }}</span>
        </template>
        <div class="list">
          <ul v-for="items in item.children" :key="items.id">
            <li @click="listClick(items)" v-if="items.id !== -202" class="create-list-subClass" :key="items.id">
              {{ items.name }}
            </li>
            <!-- <li v-else
              class="create-list-subClass"
              action=""
              :show-file-list="false"
              :before-upload="importFile"
              @click="importFile"
            >
              {{ items.name }}
            </li> -->
            <el-upload v-else class="create-list-subClass" action="" :show-file-list="false" :before-upload="importFile"
              style="border-radius: 3px;">
              <li>{{ items.name }}</li>
            </el-upload>
          </ul>
        </div>
      </el-collapse-item>
    </el-card>
    <el-dialog v-if='selectUser' :title="$t('message.title.resourceMapping')" :visible.sync="selectUser">
      <div size="mini" style="margin:15px">
        <!-- <vxe-table
          ref="taskTable"
          keep-source
          resizable
          border
          :highlightCurrentRow="true"
          :data="tableData"
          :edit-config="{trigger: 'dblclick', mode: 'cell'}"
        >
          <vxe-column field="name" title="Name" ></vxe-column>
          <vxe-column field="user" title="User" :edit-render="{
              name: '$select',
              options: userList,
              optionProps: {value: 'value', label: 'label'}
            }"></vxe-column>
        </vxe-table> -->
        <!-- <p style="font-size:14px">请选择对应的系统用户</p> -->
        <el-form>
          <div style="font-weight:800px;font: 16px;">
            <el-form-item :label="$t('message.table.fileResources')" label-width="120px">
              <span style="margin-left:15px">{{ $t('message.table.sysUser') }}</span>
            </el-form-item>
          </div>


          <el-form-item v-for="item in tableData" :key='item.index' :label="item.name" label-width="120px">
            <span>:</span>
            <el-select v-model="item.userId" filterable :placeholder="$t('message.placeholder.select')" size="small"
              style="margin-left:5px" clearable>
              <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <el-row type="flex" justify="center" style="margin-top:45px">
          <el-button type="primary" size="small" @click="submitUser">{{
            $t("message.button.submit")
          }}</el-button>
          <el-button @click="selectUser = false" size="small" type="success">{{
            $t("message.button.cancel") }}</el-button>
        </el-row>
      </div>
    </el-dialog>
  </el-collapse>
</template>

<script>
import axios from 'axios'
export default {
  props: ["list"],
  data() {
    return {
      activeNames: [],
      selectUser: false,
      userList: [],
      userId: '',
      tableData: [],
      userEdit: {},
      fileData: {},
    };
  },
  methods: {
    importFile(file) {

      let fd = new FormData();
      console.log(fd);
      fd.append("file", file);
      this.fileData = fd;
      axios.post('/ppm/impProject/validateMSPXML', fd).then(
        res => {
          console.log(res);
          if (res.data.code == 200) {
            if (!res.data.object) {
              this.subData();
              return
            }
            this.selectUser = true;
            this.userList = res.data.object.uses.map(i => {
              return { label: i.loginId, value: i.id }
            })
            this.tableData = res.data.object.resources.map(i => {
              return { name: i, userId: '' }
            })

            // this.userEdit =
            // console.log(this.userList);

            // axios.post('ppm/impProject/mapMSPResources')
          }
        }
      )

    },
    submitUser() {
      // const user = this.userList.find(i => i.value == this.userId)
      console.log(this.tableData);
      let resources = {}
      this.tableData.map(i => {

        return Object.assign(resources, { [i.name]: i.userId + '' })
      })
      axios.post('ppm/impProject/mapMSPResources', resources)
        .then(res => {
          if (res.data.code == 200) {
            this.selectUser = false;
            this.subData();
          }
        })

    },
    subData() {
      axios.post("/ppm/impProject/importMSPProject", this.fileData).then((res) => {
        // console.log(res);
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          console.log(res);
          //this.$store.commit("setClassId", res.data.object.classId);
          //this.$store.commit("setObjID", res.data.object.id);
          //this.$store.commit("setSubClassId", res.data.object.subclassId);
          this.$store.commit("setQuickCreate", {});
          // this.$router.push("/titleBlock");
          // let obj = {
          //   itemClassId: res.data.object.classId,
          //   itemId: res.data.object.id,
          //   itemSubClassId: res.data.object.subclassId,
          // };
          // obj[0] = res.data.object.name;
          // this.getRouteLink(obj);
          const item = {
            ...res.data.object,
            name: res.data.object.name
          }
          this.getLink(item);

        }
        else {
          this.$message.error(res.data.message)
        }
      });
    },
    handleChange(val) {
      // console.log(val);
      console.log(this.activeNames);
    },
    listClick(e) {
      this.$emit("getCreateInfo", e);
    },
  },
  beforeMount() {
    console.log(Object.keys(this.list));
    if (this.activeNames.length == 0) {
      this.activeNames = Object.keys(this.list).map(Number);
    }
  },
  mounted() {
    console.log(this.list);

  },
  created() {
    // console.log(this.list);
  },
  watch: {
    list(e) {
      console.log(e);
      this.activeNames = Object.keys(e).map(Number);
    },
  },
};
</script>
<style>
.create-list-subClass .el-upload {
  display: block;
}

.top.el-collapse {
  /* border-top: none !important; */
  border: none;
}

.top .el-collapse-item__arrow {
  font-size: 20px;
  color: #3ea0fb;
  font-weight: 600;
}

.top .el-collapse-item__wrap {
  border-bottom: none;
}
</style>
<style scoped>
.title {
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
  font-size: 16px;
  height: 18px;
  line-height: 18px;
}

.box-card {
  margin-top: 10px;
  margin-bottom: 5px;
}

.list {
  margin-bottom: 15px;
  padding-bottom: 15px;
  font-size: 14px;
}

.list li {
  list-style: none;
  border-radius: 3px;
}

.create-list {
  padding: 0;
  margin: 0;
  overflow: hidden;
  margin-bottom: 30px;
}

.create-list-subClass {
  width: 24%;
  height: 30px;
  overflow: hidden;
  float: left;
  text-align: center;
  background: #ebeef5;
  margin-right: 1%;
  margin-top: 10px;
  line-height: 30px;
}

.create-list-subClass:hover {
  cursor: pointer;
  background: #409eff;
  color: #fff;
}

.create-list .create-list-class {
  width: 96%;
  background: rgb(198, 226, 255);
  text-align: left;
  height: 38px;
  line-height: 38px;
  font-size: 18px;
  cursor: default;
  padding-left: 3%;
}
</style>